import { defineStore } from 'pinia'
import axios from 'axios'

export const useLocator = defineStore('locator', {
  state: () => ({
    branch: null,
    destinations: [
      {
        source: 'app.finsei.com',
        defaultBranch: 'master',
        branches: {
          master: {
            apiUrl: 'https://api.finsei.com',
            wsUrl: 'wss://ws.finsei.com/connection/websocket',
          },
        },
      },
      {
        source: 'app.demo.finsei.com',
        defaultBranch: 'master',
        branches: {
          master: {
            apiUrl: 'https://api.demo.finsei.com',
            wsUrl: 'wss://ws.demo.finsei.com/connection/websocket',
          },
        },
      },
      {
        source: 'app.sandbox.finsei.com',
        defaultBranch: 'master',
        branches: {
          master: {
            apiUrl: 'https://api.sandbox.finsei.com',
            wsUrl: 'wss://ws.sandbox.finsei.com/connection/websocket',
          },
        },
      },
      {
        source: '*', // app.test.inside.finsei.com
        defaultBranch: 'test',
        branches: {
          local: {
            apiUrl: 'https://api.altpay.my',
            wsUrl: 'wss://ws.altpay.my/connection/websocket',
            disabled: true,
          },
          dev: {
            apiUrl: 'https://api.dev.inside.finsei.com',
            wsUrl: 'wss://ws.dev.inside.finsei.com/connection/websocket',
          },
          test: {
            apiUrl: 'https://api.test.inside.finsei.com',
            wsUrl: 'wss://ws.test.inside.finsei.com/connection/websocket',
          },
          sandbox: {
            apiUrl: 'https://api.sandbox.finsei.com',
            wsUrl: 'wss://ws.sandbox.finsei.com/connection/websocket',
          },
        },
      },
    ],
  }),
  actions: {
    /**
     * Check all services for availability
     * @return {Promise<*>}
     */
    async getAvailableBranches() {
      const branches = this.getDestination.branches
      const promises = []
      const instance = axios.create({
        timeout: 500,
      })

      for (let key in branches) {
        let req = instance.get(branches[key].apiUrl)
        req.then(() => (branches[key]['disabled'] = false))
        req.catch(() => (branches[key]['disabled'] = true))
        promises.push(req)
      }

      try {
        await Promise.all(promises)
      } catch (e) {
        /* empty */
      }

      return branches
    },
  },
  getters: {
    getDestination: ({ destinations }) => {
      const my_host = document.location.host
      const list = destinations.map((i) => i.source)

      return list.includes(my_host)
        ? destinations.find((i) => i.source === my_host)
        : destinations.find((i) => i.source === '*')
    },
    getActiveBranch({ branch }) {
      return branch || this.getDestination.defaultBranch
    },
    getApiUrl() {
      return this.getDestination.branches[this.getActiveBranch].apiUrl
    },
    getWsUrl() {
      return this.getDestination.branches[this.getActiveBranch].wsUrl
    },

    isMaster() {
      return this.getActiveBranch === 'master'
    },
  },
  persist: {
    storage: sessionStorage,
    paths: ['branch'],
  },
})
